import {
  fabric, //面料列表
  zzFabric,//下单的面料列表
  getFabricStock,//查询面料库存
  } from "@/api/fabric.js";
  export default {
    state: {

    },
    actions: {
      // 面料列表
      fabricAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          fabric(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 面料列表
      zzFabricAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          zzFabric(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      //查询面料库存
      fabricStockAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          getFabricStock(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },

    },
    mutations: {

    },
    getters: {}
  };



// WEBPACK FOOTER //
// ./src/store/module/fabric.js